import { useTranslation } from "react-i18next";
import Select from "../Select";
import { Row } from "../Grid";
import { Col } from "react-bootstrap";
import NumericInput from "../NumericInput";
import TextInput from "../TextInput";

import PropTypes from 'prop-types';
import DataTable from "../DataTable";
import { useMemo } from "react";

/**
 * An editor for a collation configuration which controls how data is grouped.
 * @component
 */
const CollationMode = ({ collation, onChange }) => {
    const { t } = useTranslation();
    const groupColumns = useMemo(() => [
        { "type": "number", "field": "min", "title": t('min'), "required": true, "editable": true },
        { "type": "number", "field": "max", "title": t('max'), "required": true, "editable": true },
        { "type": "text", "field": "label", "title": t('label'), "required": true, "editable": true }
    ], [t]);

    const options = useMemo(() => [
        {value: "none", label: t('none')},
        {value: "topN", label: t('topN')},
        {value: "group", label: t('group')},
        {value: "count", label: t('count')},
        {value: "mean", label: t('mean')},
        {value: "median", label: t('median')},
        {value: "mode", label: t('mode')}], [t])
        
        
    return <>
        <Row>
            <Col>
                <Select value={collation?.mode} placeholder={t('collation')} onChange={mode => onChange({ ...collation, mode })} options={options} labelField="label" valueField="value"></Select>        
            </Col>
        </Row>
        { collation?.mode === 'topN' ? 
            <Row>
                <Col md>
                    <NumericInput placeholder="N" value={collation.n} onChange={n => onChange({ ...collation, n })}></NumericInput>
                </Col>
                <Col md>
                    <TextInput placeholder={t('otherLabel')}  value={collation.other} onChange={other => onChange({ ...collation, other })}></TextInput>
                </Col>
            </Row>
        : null}
        { collation?.mode === 'group' ?
            <Row>
                <DataTable columns={groupColumns} value={collation.groups} onChange={groups => onChange({ ...collation, groups })}></DataTable>
            </Row>
        : null}
    </>
}

CollationMode.propTypes = {
    /**
     * The collation configuration object to edit (if any)
     */
    collation: PropTypes.object,
    /**
     * A function which is called with a new collation object after a value has been updated
     */
    onChange: PropTypes.func.isRequired
}

export default CollationMode;